const styles = {
    jasperContainer:{
        width: '100%', minHeight: 800, border: 0
    }
  };

export default styles;


// WEBPACK FOOTER //
// ./src/containers/crashDashboard/styles/JasperReportStyles.js